export default __webpack_public_path__ + "static/media/notifications.201b9e28.svg";